import { useState, useMemo, useCallback } from "react"
import useResizeObserver from "web/hooks/behaviour/useResizeObserver"

const GUTTER_WIDTH = 190

export default function useVisibleColumnCount(columns, tableResizeWatchRef) {
  const [visibleColumnCount, setVisibleColumnCount] = useState()

  const dataColumnWidths = useMemo(() => {
    return columns.filter((c) => c.type === "data").map((c) => c.width)
  }, [columns])

  const updateVisibleColumnCount = useCallback(
    ([entry]) => {
      const tableWidth = entry.borderBoxSize[0].inlineSize
      const adjustedWidth = tableWidth - GUTTER_WIDTH

      const tableWidthWithGutter =
        adjustedWidth > 0 ? adjustedWidth : tableWidth

      let accumulatedWidth = 0
      let visibleColumns = 0

      for (const columnWidth of dataColumnWidths) {
        accumulatedWidth += columnWidth

        if (accumulatedWidth > tableWidthWithGutter) {
          break
        }

        visibleColumns++
      }

      setVisibleColumnCount(visibleColumns)
    },
    [dataColumnWidths]
  )

  useResizeObserver(tableResizeWatchRef, updateVisibleColumnCount)

  return visibleColumnCount
}
